import { PowerSyncDatabase } from '@powersync/web';
import { AppSchema } from './schema';
import axios from 'axios';
import { apiUrl, powerSyncDBUrl } from '../lib/config';

// PowerSync configuration
const POWERSYNC_URL = 'https://6979b18a30605f245f05dc96.powersync.journeyapps.com';

// Token provider function
export const getToken = async () => {
  let tokenTxt = localStorage.getItem('powerSyncToken');
  return tokenTxt;
};

const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp <= currentTime;
  } catch (err) {
    console.error('Invalid token:', err);
    return true;
  }
};


const refreshAuthToken = async () => {
       try {
          const rawToken = localStorage.getItem('auth_token');
          const rawLoginInfo = localStorage.getItem('login_info');
          const parsedLoginInfo = JSON.parse(rawLoginInfo);
          let initialUserInfo = null;
          let initialLoginUserId = null;
          let initialLoginUserPhone = null;

          let token = "";
          if(
            typeof parsedLoginInfo === 'object' &&
            parsedLoginInfo !== null &&
            rawToken &&
            rawToken.trim() !== ''
          ) {
            initialUserInfo = parsedLoginInfo;
            initialLoginUserId = parsedLoginInfo.userId;
            initialLoginUserPhone = parsedLoginInfo.phone;

            const response = await axios.post(
              apiUrl+'users/refresh-token',
              {
                userId: initialLoginUserId,
                phone: initialLoginUserPhone,
                sessionToken: rawToken,
                jwk: true
              },
              {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            );

            let responseData = response?.data;
            token = responseData?.data?.powerSyncToken;
            if (!token) {
              throw new Error('Token missing in response');
            }
            localStorage.setItem('powerSyncToken', token);
            localStorage.setItem('auth_token', responseData?.data?.accessToken);
          }
          
          return token;

        } catch (error) {
          console.error('Token refresh failed:', error?.response?.data || error.message);
          throw error;
        }
};


// Create PowerSync database instance
export const db = new PowerSyncDatabase({
  schema: AppSchema,
  database: {
    dbFilename: 'powersync.db'
  }
});

// Initialize PowerSync connection
export const initializePowerSync = async () => {
  try {
    await db.connect({
      powerSyncUrl: POWERSYNC_URL,
      // Token fetcher function
      fetchCredentials: async () => {
        let token = await getToken();
        if (!token || isTokenExpired(token)) {
          token = await refreshAuthToken();
        }
        return {
          endpoint: POWERSYNC_URL,
          token: token
        };
      }
    });
    
    console.log('PowerSync connected successfully');
    return db;
  } catch (error) {
    console.error('Failed to connect to PowerSync:', error);
    throw error;
  }
};
